import * as yup from 'yup'

const schema = () =>
  yup.object({
    active: yup.boolean(),
    name: yup.string().required(),
    assigneeId: yup.mixed().nullable().required(),
    description: yup.string().required(),
    departmentId: yup.string().required(),
    toDo: yup.string().required(),
    methodology: yup.string().required(),
    goal: yup.number().nullable().when('goalOperator', {
      is: 'in_between',
      then: yup.number().nullable(),
      otherwise: yup.number().nullable().required(),
    }),
    goalMin: yup
      .number()
      .nullable()
      .when('goalOperator', {
        is: 'in_between',
        then: yup
          .number()
          .nullable()
          .required()
          .test(
            'goalMin-less-than-goalMax',
            'A meta menor deve ser menor que a meta maior',
            function (value) {
              const { goalMax } = this.parent
              if (value == null || goalMax == null) return true
              return value < goalMax
            },
          ),
        otherwise: yup.number().nullable(),
      }),
    goalMax: yup
      .number()
      .nullable()
      .when('goalOperator', {
        is: 'in_between',
        then: yup
          .number()
          .nullable()
          .required()
          .test(
            'goalMax-greater-than-goalMin',
            'A meta maior deve ser maior que a meta menor',
            function (value) {
              const { goalMin } = this.parent
              if (value == null || goalMin == null) return true
              return value > goalMin
            },
          ),
        otherwise: yup.number().nullable(),
      }),
    goalOperator: yup.string().required(),
    measurementUnit: yup.string().required(),
    periodicity: yup.string().required(),
    priority: yup.string().required(),
    periodicityDay: yup
      .date()
      .typeError('O dia da periodicidade deve ser uma data válida')
      .required('O dia da periodicidade é obrigatório'),
    startDate: yup.string().nullable().required(),
    endDate: yup.string().nullable().required().afterSibling({
      field: 'startDate',
      message: 'A data de término deve ser posterior à data de início',
    }),
    formula: yup.string(),
    dataSource: yup.string(),
    attachments: yup.mixed().fileUpload(),
  })

export default schema
